import React from 'react'
// import {Navbar} from '../Components/Navbar';

export const About = () => {
  return (
    <>
      <div className = "about-content container my-4">
          <p>
          In the modern world, the most inhumane things are done by humans and the victims of that are not always able to speak out for their sufferings.
          </p> 
          <p>
            So we have come up with an idea to provide a platform where all the things related to domestic animal welfare can be found in one place, from the adoption of stray animals to an extensive database of NGOs, from FAQs on animal care to reporting animal abuse we have tried to cover it all and we call that <span> <b>"TAILS OF JOY !"</b></span>
          </p>
          <p>Ensuring animal welfare is a human responsibility that includes consideration for all aspects of animal well-being, including proper housing, management, nutrition, disease prevention and treatment, responsible care, humane handling, and, when necessary, humane euthanasia.</p>
      </div> 
    </>
  )
}
